import { BaseResource } from "./BaseResource";
import { apiResourceUrl } from "@ploy-lib/core";
export var ExtrasType;
(function (ExtrasType) {
    ExtrasType["NotSet"] = "NotSet";
    ExtrasType["Extras"] = "Extras";
    ExtrasType["Color"] = "Color";
})(ExtrasType || (ExtrasType = {}));
export class CarObjectExtraResource extends BaseResource {
    constructor() {
        super(...arguments);
        this.code = "";
    }
    pk() {
        return `${this.code}`;
    }
}
CarObjectExtraResource.urlRoot = apiResourceUrl("object-extra");
//# sourceMappingURL=CarObjectExtraResource.js.map